interface AboutHeroTexts {
  title_line1?: string;
  title_line2?: string;
  subtitle?: string;
}

export default function AboutHero({ texts }: { texts?: AboutHeroTexts }) {
  const titleLine1 = texts?.title_line1 ?? "";
  const titleLine2 = texts?.title_line2 ?? "";
  const subtitle = texts?.subtitle ?? "";

  return (
    <section className="w-full bg-white py-4 md:py-6 lg:py-8">
      <div className="w-full max-w-[1100px] mx-auto">
        <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
          <img loading="lazy"
            src="https://net-basis.net/Bilder/netbasis-international-ict-networking-dach.webp"
            alt="&Uuml;ber uns"
            title={titleLine1}
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          {/* Dark overlay for text contrast */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

          {/* Text overlay */}
          <div className="absolute inset-0 flex flex-col items-start justify-center px-4 md:px-8">
            <p
              className="text-3xl md:text-4xl lg:text-5xl font-normal text-white text-left leading-tight drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] -mt-14 md:-mt-10 lg:-mt-8 ml-2 about-hero-top-slide"
              style={{ fontFamily: '"Open Sans", sans-serif' }}
            >
              {titleLine1}
              <br className="sm:hidden" />
              {titleLine2}
            </p>
            <p
              className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white mt-12 md:mt-14 ml-6 drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] about-hero-bottom-slide"
              style={{ fontFamily: '"Open Sans", sans-serif' }}
            >
              {subtitle}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}